<template>
    <div class="dashboard-auth-layout">
        <div class="dashboard-auth-layout__wrapper">
            <div class="dashboard-auth-layout__content">
                <div class="dashboard-auth-layout__logos">
                    <img
                        src="@/assets/img/logo_pravna.svg"
                        alt="Logo aplikacji Pravna"
                    />
                </div>
                <h1 class="text-h6 text-center mt-6 mb-4 font-weight-bold">
                    Strefa Administracyjna
                </h1>
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <div :key="$route.fullPath">
                        <slot />
                    </div>
                </transition>
            </div>
            <div class="dashboard-auth-layout__footer mt-2">
                <div class="text-center text-caption grey--text">
                    &copy;{{ new Date().getFullYear() }} - Invoicing Gateway by AV Venture Building
                    | v{{ GENERAL_STORE.APP_VERSION }}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useGeneralStore } from "@/store/general.store";

const GENERAL_STORE = useGeneralStore();
</script>
